<template>
    <div>
        <div class="text-muted mb-2">Select a claim.</div>
        <div class="input-group input-group-sm mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text"><i class="fas fa-search fa-lg text-muted"></i></div>
            </div>
            <input type="text" class="form-control" placeholder="Search Claims" v-model="searchString">
        </div>                                                                
        <div class="list-group list-group-scroll">
            <template v-for="c in filteredClaims">
                <button type="button" :class="['list-group-item list-group-item-action', { 'active': selectedId == c.id }]" :key="c.id" @click="select(c)">
                    <div style="line-height: 1">{{ c.name }}</div>
                    <div v-if="c.claim_number" style="line-height: 1"><small>Claim Number: {{ c.claim_number }}</small></div>
                    <div style="line-height: 1"><small>Injury Date: {{ c.injury_date }}</small></div> 
                    <div style="line-height: 1"><small>Provider: {{ c.provider_name }}</small></div>                     
                </button>
            </template>
        </div>        
    </div>
</template>

<script>
export default {
    props: {
        clientId: Number,
        claim: Object,
    },
    data() {
        return {
            selectedId: this.claim ? this.claim.id : null,
            searchString: '',
            claims: []            
        }
    },
    computed: {
        filteredClaims: function() {
            var self = this;
            return self.claims.filter(function(claim) {
                return ((claim.name.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1) ||
                        (claim.claim_number && claim.claim_number.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1));
            });
        }  
    },
    methods: {
        select: function (claim) {
            this.selectedId = claim.id;
            this.$emit('update:claim', claim);
        }
    },
    created() {
        axios.get('/ajax/inbox/clients/' + this.clientId + '/claims')
            .then(response => {
                this.claims = response.data;
            })
            .catch(error => {
                // TODO: handle errors with toastr
            });        
    },
}
</script>

<style scoped>
    .list-group-scroll {
        max-height: 500px; 
        overflow: scroll; 
        -webkit-overflow-scrolling: touch;
    }
</style>